import { PropertyPanel } from "components/propertyPanel";
import { sectionsForOneApparatus } from "panel/apparatus_panel_ui";
import { arrowPanelUI } from "panel/arrow_panel_ui";
import { sectionsForDiagram } from "panel/diagram_panel_ui";
import { sectionsForMultipleItems } from "panel/propertyPanel";
import { sectionsForMultipleItemsOfSameType } from "panel/same_type_apparatus";
import * as React from "react";
import { TierContext } from "tiers/context";
/**
 * Adapter element that basically contians a PropertyPanel
 * and is responsible for creating elements for the property
 * panel based on the current state of the app.
 */
export class PropertyPanelAdapter extends React.Component {
    constructor(props) {
        super(props);
    }
    // Creates PropertyPanel props from current selection.
    createPropsForChild(tiers) {
        const { selected, app } = this.props;
        if (this.props.selected.isEmpty) {
            return sectionsForDiagram(this.props.theme, app);
        }
        else if (selected.items.length == 1 && selected.arrows.length == 0) {
            return sectionsForOneApparatus(selected.items[0], app, tiers, selected);
        }
        else if (selected.items.length == 0 && selected.arrows.length == 1) {
            return arrowPanelUI(selected, selected.arrows, app, tiers);
        }
        else if (selected.items.length == 0 && selected.arrows.length >= 1) {
            return arrowPanelUI(selected, selected.arrows, app, tiers);
        }
        else if (selected.items.length > 1 && (selected.sameApparatusType || selected.sameApparatusKind)) {
            return sectionsForMultipleItemsOfSameType(selected, app, tiers);
        }
        else {
            return sectionsForMultipleItems(selected, app);
        }
    }
    render() {
        return React.createElement(TierContext.Consumer, { key: "PropPanelConsumer" }, tiers => (React.createElement(PropertyPanel, Object.assign({}, this.createPropsForChild(tiers), { key: "PropertyPanel", onToggleCollapsed: this.props.onToggleCollapsed, collapsed: this.props.collapsed }))));
    }
}
